interface MaskOptions {
  startLen?: number
  endLen?: number
  mask?: string
  keepFullLength?: number // 直接展示全长的阈值
}

function maskString(str: string, options: MaskOptions = {}): string {
  const {
    startLen = 3,
    endLen = 3,
    mask = '***',
    keepFullLength = 6, // 可配置的阈值
  } = options

  if (typeof str !== 'string') return ''

  const totalLength = str.length

  // 长度≤阈值时直接返回
  if (totalLength <= keepFullLength) {
    return str
  }

  // 长度不足以脱敏时返回掩码
  if (totalLength <= startLen + endLen) {
    return mask
  }

  return str.slice(0, startLen) + mask + str.slice(-endLen)
}

export { maskString }
// 测试不同配置
// console.log(advancedMaskString("123456")); // 123456
// console.log(advancedMaskString("123456", { keepFullLength: 8 })); // 123456 (长度6<8，仍直接展示)
// console.log(advancedMaskString("123456789", { keepFullLength: 8 })); // 123***789 (长度9>8，脱敏)
